import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableCheckBox from "../../../Component/BasicComponents/ReusableCheckbox";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { useGetGradeMastersData } from "../../Employee/hooks/useEmployee";
import { useLeaveTypesData, usePolicyYear } from "../hooks/useLeave";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useGetOrgUnitsData,
  useGradeMastersData,
} from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { showToast } from "../../../utils/toastUtils";
import { Input, Spinner } from "reactstrap";
interface LeaveConfigModalContentProps {
  handleSubmit: (formData: any) => void;
  handleClose: () => void;
  editLeaveConfigurationModal: string;
  selectedRowData: any;
  buttonDisable?: boolean;
}

const LeaveConfigurationModal: React.FC<LeaveConfigModalContentProps> = ({
  handleSubmit,
  handleClose,
  editLeaveConfigurationModal,
  selectedRowData,
  buttonDisable,
}) => {
  // console.log(
  //   "🚀 ~ LeaveConfigurationModal.tsx:30 ~ selectedRowData:",
  //   selectedRowData
  // );

  const [formValues, setFormValues] = useState({
    name: "",
    grade: 0,
    policyYear: "",
    leaveType: "",
    leavePoints: "",
    applyDate: "",
    selectedOrgUnits: [] as { id: number; name: string }[],
    attachment: "",
    adminApproval: "",
    isActive: false,
    showAttachment: false,
    showAdminApproval: false,
  });
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [backupAttachment, setBackupAttachment] = useState("");
  const [backupAdminApproval, setBackupAdminApproval] = useState("");

  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });
  const { data: gradeMasterData } = useGetGradeMastersData({ enable: true });
  const { data: leaveTypeDataa } = useLeaveTypesData({ enable: true });
  const { data: gradeMasterDataa } = useGradeMastersData({ enable: true });
  const { data: policyYearData } = usePolicyYear({ enable: true });

  console.log(
    "🚀 ~ LeaveConfigurationModal.tsx:58 ~ policyYearData:",
    policyYearData?.data
  );

  const formattedPolicyYearData = policyYearData?.data?.map((item: any) => ({
    id: item,
    label: item,
  }));

  console.log(
    "🚀 ~ LeaveConfigurationModal.tsx:68 ~ formattedPolicyYearData ~ formattedPolicyYearData:",
    formattedPolicyYearData
  );

  const transformedData = leaveTypeDataa?.data.map((item: any) => ({
    id: item.ShortCode,
    label: item.LeaveType.trim(), // Using .trim() to remove extra spaces if needed
  }));
  const formattedGradeData = gradeMasterDataa?.data.map((item: any) => ({
    id: item.Gradeid,
    label: item.GradeName.trim(), // Using .trim() to remove extra spaces if needed
  }));

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any, index: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["attachment", "leavePoints"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormValues((prevState) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  // Handle dropdown selection
  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  // Handle multi-select dropdown
  const handleMultiSelectChange = (selectedValues: string[] | number[]) => {
    const selectedData = selectedValues.map((id) =>
      formattedOrgUnitData.find((unit: any) => Number(unit.id) === Number(id))
    );

    setFormValues((prevState: any) => ({
      ...prevState,
      selectedOrgUnits: selectedData.filter(Boolean), // Filter out undefined values
    }));
  };

  // Handle checkbox change
  // const handleCheckboxChange = (checked: boolean) => {
  //   setFormValues({ ...formValues, isActive: checked });
  // };

  const handleToggleChange = () => {
    setFormValues((prev) => ({
      ...prev,
      isActive: !prev.isActive,
    }));
  };

  useEffect(() => {
    if (editLeaveConfigurationModal === "Update" && selectedRowData) {
      if (!orgUnitLoading && formattedOrgUnitData?.length > 0) {
        const selectedOrgUnits = selectedRowData?.Orgunitids.split(",")
          .map((id: string) => {
            const matchedUnit = formattedOrgUnitData.find(
              (unit: any) => Number(unit.id) === Number(id)
            );
            return matchedUnit
              ? { id: Number(id), name: matchedUnit.label }
              : null;
          })
          .filter(Boolean); // Filter out undefined values

        setFormValues({
          name: selectedRowData?.Name || "",
          grade: selectedRowData?.GradeId || 0,
          policyYear: selectedRowData?.PolicyYear || "",
          leaveType: selectedRowData?.LeaveType || "",
          leavePoints: selectedRowData?.LeavePoints || "",
          applyDate: selectedRowData?.ApplyDate || "",
          selectedOrgUnits: selectedOrgUnits,
          attachment: selectedRowData?.IsAttachmentReq?.toString() || "",
          adminApproval: selectedRowData?.AdminApproval?.toString() || "",
          isActive: selectedRowData?.IsActive || false,
          showAttachment: !!selectedRowData?.IsAttachmentReq,
          showAdminApproval: !!selectedRowData?.AdminApproval,
        });
      }
    }
  }, [selectedRowData, orgUnitLoading]);

  return (
    <>
      {orgUnitLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
        </div>
      ) : (
        <div>
          <div className="row mb-0">
            <div className="col-sm-4">
              <CustomInput
                label="Name"
                asterisk={true}
                placeholder="Enter Name"
                type="text"
                name="name"
                value={formValues.name}
                onChange={(e) => handleInputChange("name", e)}
              />
            </div>
            <div className="col-sm-4">
              <ReusableDropdown
                options={formattedOrgUnitData || []}
                isMulti={true}
                value={formValues?.selectedOrgUnits.map((unit) =>
                  unit.id.toString()
                )}
                onChange={(value: any) => {
                  handleMultiSelectChange(value);
                }}
                asterisk={true}
                DropdownHeading="Org Unit"
                placeholder="Select Org Unit"
              />
            </div>
            <div className="col-sm-4">
              <ReusableDropdown
                options={formattedGradeData || []}
                value={formValues.grade || selectedRowData?.GradeId}
                onChange={(value: any) => {
                  handleDropdownSelect("grade", value);
                }}
                DropdownHeading="Grade"
                asterisk={true}
                placeholder="Select Grade"
              />
            </div>
            <div className="col-sm-4">
              <ReusableDropdown
                options={formattedPolicyYearData || []}
                onChange={(value: any) => {
                  handleDropdownSelect("policyYear", value);
                }}
                DropdownHeading="Policy Year"
                asterisk={true}
                value={formValues.policyYear?.toString()}
                placeholder="Select Policy Year"
              />
            </div>
            <div className="col-sm-4">
              <ReusableDropdown
                options={transformedData || []}
                onChange={(value: any) => {
                  handleDropdownSelect("leaveType", value);
                }}
                DropdownHeading="Leave Type"
                asterisk={true}
                value={formValues?.leaveType || selectedRowData?.LeaveType}
                placeholder="Select Leave Type"
              />
            </div>
            <div className="col-sm-4">
              <CustomInput
                label="Leave Points ( In Days )"
                asterisk={true}
                placeholder="Enter Leave Points"
                type="number"
                name="leavePoints"
                value={formValues?.leavePoints}
                onChange={(e) => handleInputChange("leavePoints", e)}
              />
            </div>
            <div className="col-sm-4">
              <CustomInput
                label="Applicable Date"
                asterisk={true}
                placeholder="Enter Apply Date"
                type="date"
                name="applyDate"
                value={formValues.applyDate}
                onChange={(e) => handleInputChange("applyDate", e)}
              />
            </div>

            <div className="col-sm-4 mt-5">
              <div className="col-sm-12">
                <ReusableCheckBox
                  data={[
                    {
                      label: "Attachment",
                      value: "attachment",
                      checked: formValues.showAttachment,
                    },
                  ]}
                  style={{ padding: 0 }}
                  onCheckedChange={(checkedItems) =>
                    setFormValues((prev) => {
                      const isChecked = checkedItems.includes("attachment");
                      if (!isChecked)
                        setBackupAttachment(prev.attachment.toString());
                      return {
                        ...prev,
                        showAttachment: isChecked,
                        attachment: isChecked
                          ? backupAttachment || prev.attachment
                          : "",
                      };
                    })
                  }
                />
              </div>

              {/* Show input below checkbox */}
              {formValues.showAttachment && (
                <div className="col-sm-12 mt-2">
                  <CustomInput
                    label="Attachment ( In Days )"
                    placeholder="Enter Attachment"
                    type="number"
                    name="attachment"
                    value={formValues.attachment}
                    onChange={(e) => handleInputChange("attachment", e)}
                  />
                </div>
              )}
            </div>

            <div className="col-sm-4 mt-5">
              <div className="col-sm-12">
                <ReusableCheckBox
                  data={[
                    {
                      label: "Admin Approval",
                      value: "adminApproval",
                      checked: formValues.showAdminApproval,
                    },
                  ]}
                  style={{ padding: 0 }}
                  onCheckedChange={(checkedItems) =>
                    setFormValues((prev) => {
                      const isChecked = checkedItems.includes("adminApproval");
                      if (!isChecked)
                        setBackupAdminApproval(prev.adminApproval.toString());
                      return {
                        ...prev,
                        showAdminApproval: isChecked,
                        adminApproval: isChecked
                          ? backupAdminApproval || prev.adminApproval
                          : "",
                      };
                    })
                  }
                />
              </div>

              {/* Show input below checkbox */}
              {formValues.showAdminApproval && (
                <div className="col-sm-12 mt-2">
                  <CustomInput
                    label="Admin Approval ( In Days )"
                    placeholder="Enter Admin Approval"
                    type="number"
                    name="adminApproval"
                    value={formValues.adminApproval}
                    onChange={(e) => handleInputChange("adminApproval", e)}
                  />
                </div>
              )}
            </div>

            {/* Checkbox */}
            <div
              className="col-sm-3 form-check form-switch mb-3"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "40px",
                justifyContent: "flex-start",
                marginLeft: "-12px",
                // backgroundColor: "red",
              }}
            >
              <label style={{ fontWeight: "400" }}>Is Active?</label>
              <Input
                type="switch"
                checked={formValues?.isActive}
                onChange={handleToggleChange}
                style={{
                  marginBottom: "8px",
                  minHeight: "1.5em",
                  width: "3em",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-start gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
              disabled={buttonDisable}
              onClick={() => {
                // setIsSubmitting(true);
                handleSubmit({
                  ...formValues,
                  selectedOrgUnits: formValues.selectedOrgUnits.map(
                    (item) => item.id
                  ), // Extract only IDs here
                });
              }}
            >
              {editLeaveConfigurationModal === "Submit" ? "Submit" : "Update"}
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
              onClick={handleClose}
            >
              Cancel
            </Btn>
          </div>
        </div>
      )}
    </>
  );
};

export default LeaveConfigurationModal;
